module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iI2M2MGMzMCIgZD0iTTAgMGg1MTIuMXY1MTJIMHoiLz4KICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMTQ0IDBoNzMuMTQzdjUxMkgxNDR6Ii8+CiAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMjE5LjQzaDUxMi4xdjczLjE0MkgweiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/dk.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/dk.svg
// module chunks = 0